module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Underline-3e8c81445050e41aaf1b2b29975a0758.svg";